<template>
  <div id="app">
    <div class="page-container">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Segoe UI", "Microsoft YaHei", sans-serif;
}

body, html {
  width: 100%;
  height: auto !important;
  overflow: visible !important;
  overflow-x: hidden !important; 
}
#app {
  width: 100%;
  height: auto !important;
  overflow: visible !important;
  overflow-x: hidden !important; 
}

.home-page, .products-page, .events-page, .careers-page {
  height: auto !important;
  overflow: visible !important;
  overflow-x: hidden !important; 
  width: 100%; 
}

.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100px; 
  background: #fff;
  z-index: 999;
  margin: 0 !important;
  padding: 0 !important;
}

.page-container {
  padding-top: 100px;
  width: 100%;
  min-height: 100vh;
  margin: 0 !important;
}

a {
  text-decoration: none;
  color: inherit;
}
ul,
li {
  list-style: none;
}
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
}
.page-container {
  padding-top: 90px; 
}
</style>